import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile, addApplication, editApplication } from './request';
import { cryptoDecrypt } from '@/utils/aes';
import { customerResource } from './../../system/customerManage/request';
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  props: {
    currentRow: [Object, null],
    dialogVisible: Boolean,
    tableData: Array,
    seeInfo: Boolean
  },
  data() {
    return {
      headers: {
        'X-Dispatch': 'Upload',
        'X-Version': 'upload'
      },
      imageUrl: '',
      action: uploadFile,
      type: [],
      from: {
        name: '',
        appid: '',
        introduce: '',
        type: undefined,
        icon: '',
        customerId: undefined
      },
      customerList: [],
      defaultCheckedList: [],
      loading: false
    };
  },
  computed: {
    roleList() {
      return this.tableData.map(item => item.role);
    },
    roleRule() {
      return {
        customerId: [{
          required: true,
          message: this.$t('请选择') + this.$t('牌照所属'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入应用名称')
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('应用类型'),
          trigger: 'change'
        }]
      };
    }
  },
  mounted() {
    console.log(this.seeInfo);
    this.from = {
      ...this.currentRow
    } || {};
    customerResource({
      isLicense: 1
    }).then(res => {
      this.customerList = res;
    });
    console.log(this.from);
    if (this.from.icon) {
      this.imageUrl = this.from.icon;
    }
  },
  methods: {
    onCheckboxChange(e) {
      console.log(e);
      this.type = e;
      this.from.type2 = e;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleSure() {
      console.log(55);
      this.$refs.from.validate(valid => {
        this.loading = true;
        if (valid) {
          if (this.currentRow.id) {
            editApplication(this.from).then(res => {
              this.$message.success(this.$t('修改成功') + '!');
              this.loading = false;
              this.$emit('ok');
            });
          } else {
            addApplication(this.from).then(res => {
              this.$message.success(this.$t('添加成功') + '!');
              this.loading = false;
              this.$emit('ok', res);
            });
          }
        }
      });
    },
    handleChange(info) {
      console.log(info);
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        let infoObj = process.env.NODE_ENV === 'production' ? cryptoDecrypt(info.file.response.data) : info.file.response.data;
        console.log(infoObj);
        this.from.icon = infoObj.fileTempUrl;
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    }
  }
};